import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

// Async thunk to fetch deals list
export const fetchDealsList = createAsyncThunk(
  "deals/fetchDealsList",
  async ({ selectedStatus, dealCategoryId }, { rejectWithValue }) => {
    try {
      const formattedStatus = Array.isArray(selectedStatus) ? selectedStatus.join(",") : selectedStatus;
      const response = await axios.get(
        `/api/admin/allDealsList?statusId=${formattedStatus}&dealCategoryId=${dealCategoryId}`,
      );
      return response.response;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const rejectJVDeal = createAsyncThunk(
  "jointVenturesDeals/rejectJVDeal",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/rejectJVDeal", payload);
      return (
        response?.message ||
        response?.response?.message ||
        "JV deal rejected successfully"
      );
    } catch (err) {
      return rejectWithValue(
        err.response?.data || err.message || "Failed to reject deal",
      );
    }
  },
);

const jointVenturesDealsSlice = createSlice({
  name: "jointVenturesDeals",
  initialState: {
    deals: [],
    loading: false,
    error: null,
    rejectJVDealLoading: false,
    rejectJVDealError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDealsList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDealsList.fulfilled, (state, action) => {
        state.loading = false;
        state.deals = action.payload || [];
      })
      .addCase(fetchDealsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch deals list";
      })
      .addCase(rejectJVDeal.pending, (state) => {
        state.rejectJVDealLoading = true;
        state.rejectJVDealError = null;
      })
      .addCase(rejectJVDeal.fulfilled, (state, action) => {
        state.rejectJVDealLoading = false;

        const rejectedDealId = action?.meta?.arg?.dealId;
        if (!rejectedDealId || !Array.isArray(state.deals)) return;

        state.deals = state.deals.map((deal) => {
          if (String(deal?.dealId) !== String(rejectedDealId)) return deal;
          return {
            ...deal,
            dealStatus: "Rejected",
            statusId: "DSC1000012",
          };
        });
      })
      .addCase(rejectJVDeal.rejected, (state, action) => {
        state.rejectJVDealLoading = false;
        state.rejectJVDealError = action.payload || "Failed to reject deal";
      });
  },
});

export default jointVenturesDealsSlice.reducer;
